<div class="ui-legend-item">
  <div class="ui-legend-circle" [ngStyle]="{'background-color': color||'#5C5C5C'}"></div>
  <div class="ui-legend-text">
    <ng-content></ng-content>
  </div>
</div>
